import styled from "styled-components";
export const OrdersWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
